import { render } from "./EventRegisterSuccess.vue?vue&type=template&id=0d4e7733"
import script from "./EventRegisterSuccess.vue?vue&type=script&lang=js"
export * from "./EventRegisterSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/megaluzz-admin/megaluzz-admin/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__